import { Link, useLocation } from "react-router-dom";
// import Logo from "../assets/main_logo.svg";
import clsx from 'clsx';
import {useThemeClass} from '@/Hooks/useThemeClass'
import {useThemeAsset} from '@/Hooks/useThemeAsset'

function Footer() {
  const themeClass = useThemeClass()
  const {logo, grayscaleLogo} = useThemeAsset()
  const {pathname} = useLocation()
    const match = location.pathname.match(/^\/review-guide\/[^/]+$/);

  return (
    <div className={`${pathname === "/map-campaign" || match ? "hidden" : clsx(themeClass.bg('background'), 'bottom-0') }`}>
      <div className="max-w-[560px] mx-auto pt-[56px] lg:max-w-4xl xl:max-w-[90em]">
      <div className="items-center lg:mt-36  mt-10 px-4 bottom-0 relative border-t border-gray-200 pt-5 ">
        <div className="">
          <div className="flex justify-between items-center pb-5">
            <div className="flex flex-wrap items-center gap-4 text-[12px] font-medium text-gray-700 hover:text-gray-900">
              <Link 
                to={"/privacy"}
                className="cursor-pointer hover:underline"
              >
                개인정보처리방침
              </Link>
              <Link
                to="/customerservice"
                className="cursor-pointer hover:underline"
              >
                고객센터
              </Link>
              <Link
                to="/contact"
                target="_blank"
                className="hover:underline"
              >
                광고문의
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="items-center   px-4 bottom-0 relative border-t border-gray-200 py-6 ">
        <div className="">
          <div className="text-gray-500 text-[10px] md:text-[12px] flex justify-between items-end pb-4">
            <div>
            <div className="flex flex-wrap gap-2">
              <p>대표이사: 이경철</p>
              <p className=""> | </p>
              <p>개인정보보호책임자: 이경철</p>
            </div>
            <p>주소: 서울시 송파구 올림픽로 300 롯데월드타워 워크플렉스 30F</p>
            <p className="mb-4">고객센터: 070-7777-4556</p>
            <div className="flex flex-wrap gap-2">
              <p>주식회사 케이씨코퍼레이션(KC Corporation)</p>
              <p className=""> | </p>
              <p>610-87-01850</p>
            </div>
            <div className="flex flex-wrap gap-2">
              <p>주식회사 윤슬커뮤니케이션즈</p>
              <p className=""> | </p>
              <p>668-88-02699</p>
            </div>
            <div className="flex flex-wrap  gap-2">
              <p>주식회사 케이스타일허브</p>
              <p className=""> | </p>
              <p>606-86-64432</p>
            </div>
            <div className="flex flex-wrap  gap-2 mb-4">
              <p>주식회사 서울언니들</p>
              <p className=""> | </p>
              <p>601-87-01079</p>
            </div>
            <p className="mb-4">통신판매업신고번호: 제2022-서울광진-1987호</p>
            <p className="text-black">
              © WE:U Corporation. All Rights Reserved.
            </p>
          </div>
          <div className="">
            <img
              src={logo}
              height={26}
              width={60}
              alt="Logo"
              className={clsx(`mx-auto p-2`, grayscaleLogo && 'grayscale opacity-50')}
            />
          </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}

export default Footer;
